

<mat-form-field 
    class="full-width" 
    (blur)="touchedSubject.next(true)"  
    [ngClass]="{'readonly-field':readOnlyObs | async}" 
    (focus)="this.focusedSubject.next(true)"
>

    <mat-label ssFormLabel></mat-label>

    <mat-chip-set class="max-height-20">

        <mat-chip-option 
            class="border-gray" 
            *ngFor="let selectedItem of selectedItemsSubject | async"  
            [selectable]="false"
        >
            {{getDisplayObs(selectedItem) | async}}
            
            <button type="button" matChipRemove (click)="remove(selectedItem)" [disabled]="readOnlyObs | async">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip-option>
  
    </mat-chip-set>

    <div matFormFieldCtrl (containerClick)="focusedSubject.next(true);">
        <input  
            #input
            matInput
            [readonly]="readOnlyObs | async"
            [matAutocomplete]="autocomplete"
            (focus)="focusedSubject.next(true)"
            (blur)="touchedSubject.next(true);focusedSubject.next(false)"
        />
    </div>
    

    <mat-autocomplete   #autocomplete
                        [displayWith]="displayWithObs | async"
    >
        <mat-option 
            *ngFor="let item of displayedDataObs | async" 
            [value]="item" 
            class="flex-row padding-standard-inline flex--align-center" 
            (onSelectionChange)="select(item);"
        >
            <mat-checkbox color="primary" class="pointer-events-none mat-body-2" [checked]="item.selected"></mat-checkbox>
            <span class="mat-body-2">{{item.display}}</span>
        </mat-option>
        

    </mat-autocomplete>

    <mat-error ssFormValidationMessage></mat-error>

    <div matSuffix class="form-field-fix">

        <button type="button"
                mat-icon-button
                editorClear
                stopPropagation
                (click)="valueSubject.next([])"
                [events]="['click','focus']"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>
</mat-form-field>

